// extracted by mini-css-extract-plugin
export default {"card":"Level_card__xtJHt","image":"Level_image__LltJG","progress":"Level_progress__f0DNF","level":"Level_level__iqV2k","line":"Level_line__KBtOQ","caption":"Level_caption__Gi0Sq"};